export class ColorDto {
  id: number;
  label: string;
  className: string;
}
